export default "__VITE_ASSET__DhZo5P99__"